<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Equipe</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Nome da Equipe:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="entity.equipe_nome"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> CNES:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="entity.cnes"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name"> Veículo: </label>
                        <select
                          class="form-control"
                          v-model="entity.veiculo_id"
                        >
                          <option
                            v-for="veiculo in veiculos"
                            :key="veiculo.veiculo_id"
                            :value="veiculo.veiculo_id"
                          >
                            {{ veiculo.placa_veiculo }} -
                            {{ veiculo.nome_veiculo }}
                          </option>
                        </select>
                      </div>
                      <!-- <div class="form-group col-md-6">
                        <label> Usuário </label>
                        <v-select
                          :options="usuarios"
                          :reduce="(usuarios) => usuarios.id"
                          :label="'usuario_nome'"
                          v-model="entity.usuario_id"
                          class="vselect"
                        />
                      </div> -->

                      <div class="form-group col-md-3">
                        <label for="Name"> Status: </label>
                        <select v-model="entity.status" class="form-control">
                          <option :value="1">Ativo</option>
                          <option :value="2">Inativo</option>
                        </select>
                      </div>

                      <div class="form-group col-md-3">
                        <label for="Name"> Região: </label>
                        <select class="form-control" v-model="entity.regiao_id">
                          <option
                            v-for="regiao in regioes"
                            :key="regiao.regiao_id"
                            :value="regiao.regiao_id"
                          >
                            {{ regiao.nome }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/equipes" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      entity: {
        equipe_nome: "",
        veiculo_id: "",
        status: "1",
        cnes: "",
        regiao_id: "",
      },
      veiculos: [],
      regioes: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "equipes";

      if (self.entity.equipe_id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.equipe_id;
      }

      axios
        .post(api, self.entity)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/equipes");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api = self.$store.state.api + "equipes/" + id;

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVeiculos: function () {
      const self = this;
      let api = self.$store.state.api + "veiculo?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.veiculos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRegioes: function () {
      const self = this;
      let api = self.$store.state.api + "regioes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.regioes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsuario: function () {
      const self = this;
      let api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.usuarios = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getVeiculos();
    self.getRegioes();

    let id = self.$route.params.id;
    if (id) {
      self.getEntity(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>